import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const HomePage = () => {
  // Use our custom hook
  useRandomLinkColors();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // Check if we're on mobile based on screen width
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // 768px is the md breakpoint in Tailwind
    };
    // Check initially
    checkMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);
    // Clean up
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  // Ensure header links get random colors on initial render
  useEffect(() => {
    const headerLinks = document.querySelectorAll('header a');
    headerLinks.forEach(link => {
      // Always apply a random color on initial render, regardless of data-color-applied attribute
      link.style.color = getRandomColor();
      link.dataset.colorApplied = 'true';
    });
  }, []);
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-222" data-mp="17kjnryh8fedv">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-50" data-id="element-223" data-mp="1chjxcjdaiz9q">
        <div className="flex space-x-6" data-id="element-224" data-mp="2085tbca0st3d">
          <div className="text-base font-normal" data-id="element-225" data-mp="2097ewaonwxzc">Madeleine Morlet</div>
          <div className="text-base font-normal" data-id="element-226" data-mp="257ipinms7cim">
            <Link to="/info" className="transition-colors duration-200"
          // Apply random color directly in the JSX to ensure it's visible
          style={{
            color: getRandomColor()
          }} data-color-applied="true" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = getRandomColor(); // Use random color on leave too
          }} data-id="element-227" data-mp="2567kkkhlnypx">
              Info
            </Link>
          </div>
        </div>
      </header>
      <main className="flex items-center justify-center min-h-screen" data-id="element-228" data-mp="2cpgk7m0b0j1s">
        <div className="w-full max-w-xl px-4" data-id="element-229" data-mp="27rosarznswxl">
          {/* Empty loading placeholder without text */}
          {!imageLoaded && <div className="w-full aspect-[4/3] bg-gray-50 border border-gray-100 flex items-center justify-center" data-id="element-230" data-mp="23qlesc533czj"></div>}
          {/* Desktop View (with hover effect) */}
          {!isMobile && <div className="relative" onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} onTouchStart={() => setIsHovering(!isHovering)} // Toggle on touch for mobile
        data-id="element-231" data-mp="1ts5x0zry5g2p">
              {/* Image and text overlay container */}
              <div className="relative overflow-hidden" data-id="element-232" data-mp="3j4rafrhepujv">
                {/* Rainbow image */}
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qUj4p6NCfXo8eW89Phqk6D/Madeleine_Morlet_13.jpg" alt="Rainbow over water with silhouettes of trees" className={`w-full h-auto transition-opacity duration-500 ${!imageLoaded ? 'hidden' : ''} ${isHovering ? 'opacity-0' : 'opacity-100'} ${!isHovering ? 'border border-gray-200 shadow-sm' : ''}`} loading="eager" onLoad={() => setImageLoaded(true)} width="800" height="600" data-id="element-233" data-mp="3rli5r22rmoy9" />
                {/* Text overlay that appears on hover */}
                <div className={`absolute inset-0 bg-[#faf9f7] overflow-y-auto transition-opacity duration-500 ${isHovering ? 'opacity-100' : 'opacity-0'}`} style={{
              height: '100%',
              display: isHovering ? 'block' : 'none'
            }} data-id="element-234" data-mp="3morpoeqyntcu">
                  <p className="text-base h-full m-0" style={{
                lineHeight: '1.58',
                padding: '0',
                boxSizing: 'border-box',
                display: 'block'
              }} data-id="element-235" data-mp="2avhdeakiayzh">
                    Not long after returning from Los Angeles, in those liminal
                    months before we move from the States back to London, I buy
                    a set of eight farmhouse chairs off Facebook Marketplace.
                    It's the start of September and it's blistering hot, humid
                    too. The air is too wet to breathe. I plan to drive over an
                    hour through country roads to a strip mall carpark for the
                    exchange. My phone has ten percent battery, the charger in
                    the truck is broken, as is the power steering, the right
                    front tyre is letting out air, and the air conditioner is
                    stuck on hot. I need to have the windows closed to hear the
                    sat nav, and I am sweating bullets. After I load the chairs
                    onto the truck, it starts to bucket down—those thick, heavy
                    droplets that come with high humidity. The truck is
                    hydroplaning and my whole body prickles with adrenaline. I
                    am driving down a mountain on a newly resurfaced road that
                    curves dramatically, on either side of me, an incline and
                    decline of evergreen. A patch of sun breaks through the dark
                    sky and I see a rainbow forming ahead, rolling down the
                    mountain, across the road, and into the forest. I drive
                    through that rainbow. <em data-id="element-236" data-mp="2pkae2ml9vx2g">Through the actual rainbow</em>.
                    For what feels like minutes, I am <em data-id="element-237" data-mp="2tlccx2ba273w">inside colour</em>.
                    The truck fills with red and blue and yellow and green and
                    violet as if all at once. I Google it later and, according
                    to the laws of physics, it's impossible.
                  </p>
                </div>
              </div>
              {/* Caption */}
              {imageLoaded && <div className="text-xs italic mt-2 ml-1" data-id="element-238" data-mp="ldpkyaydab0f">
                  * {isHovering ? 'text' : 'image'}
                </div>}
            </div>}
          {/* Mobile View (image at top, text below) */}
          {isMobile && imageLoaded && <div className="relative pt-20 pb-12" data-id="element-239" data-mp="1905uni277mc6">
              {/* Image at the top */}
              <div className="mb-6" data-id="element-240" data-mp="14yu5fdn8l34i">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qUj4p6NCfXo8eW89Phqk6D/Madeleine_Morlet_13.jpg" alt="Rainbow over water with silhouettes of trees" className="w-full h-auto border border-gray-200 shadow-sm" loading="eager" width="800" height="600" data-id="element-241" data-mp="151ydwn7qil0z" />
                <div className="text-xs italic mt-2 ml-1" data-id="element-242" data-mp="297kso94vpu6c">* image</div>
              </div>
              {/* Text below the image */}
              <div className="bg-[#faf9f7] mt-6 mb-12" data-id="element-243" data-mp="2iz72c11kjl6z">
                <p className="text-base m-0" style={{
              lineHeight: '1.58'
            }} data-id="element-244" data-mp="2j0ruxl4bou27">
                  Not long after returning from Los Angeles, in those liminal
                  months before we move from the States back to London, I buy a
                  set of eight farmhouse chairs off Facebook Marketplace. It's
                  the start of September and it's blistering hot, humid too. The
                  air is too wet to breathe. I plan to drive over an hour
                  through country roads to a strip mall carpark for the
                  exchange. My phone has ten percent battery, the charger in the
                  truck is broken, as is the power steering, the right front
                  tyre is letting out air, and the air conditioner is stuck on
                  hot. I need to have the windows closed to hear the sat nav,
                  and I am sweating bullets. After I load the chairs onto the
                  truck, it starts to bucket down—those thick, heavy droplets
                  that come with high humidity. The truck is hydroplaning and my
                  whole body prickles with adrenaline. I am driving down a
                  mountain on a newly resurfaced road that curves dramatically,
                  on either side of me, an incline and decline of evergreen. A
                  patch of sun breaks through the dark sky and I see a rainbow
                  forming ahead, rolling down the mountain, across the road, and
                  into the forest. I drive through that rainbow.{' '}
                  <em data-id="element-245" data-mp="1soyprkb8j3q4">Through the actual rainbow</em>. For what feels like
                  minutes, I am <em data-id="element-246" data-mp="1xobhaid1wyz1">inside colour</em>. The truck fills with red
                  and blue and yellow and green and violet as if all at once. I
                  Google it later and, according to the laws of physics, it's
                  impossible.
                </p>
                <div className="text-xs italic mt-4 ml-1" data-id="element-247" data-mp="1opq0arn89s0d">* text</div>
              </div>
            </div>}
        </div>
      </main>
    </div>;
};
export default HomePage;